// store
const S = {}

// events
const E = {
  updateStationInfobox: 'usi',
  updateCityInfobox: 'uci',
  hideStationInfobox: 'hsi',
  hideCityInfobox: 'hci',
  windowResize: 'wr',
  breakpointChanged: 'bc',
  clearResults: 'cr',
  jumpTo: 'jt',
  showLegend: 'sl'
}

// event bus
const C = riot.observable()

C.on(E.windowResize, width => {
  const bp = S.getActiveBreakpoint(width)
  if (S.breakpoint !== bp) {
    S.breakpoint = bp
    C.trigger(E.breakpointChanged, bp)
  }
})

// make sure only one infobox is shown
C.on(E.updateCityInfobox, () => C.trigger(E.hideStationInfobox))
C.on(E.updateStationInfobox, () => C.trigger(E.hideCityInfobox))

// open city infobox on jumpTo event on bigger screens
C.on(E.jumpTo, data => {
  if (['xsmall', 'small'].indexOf(S.breakpoint) < 0) {
    C.trigger(E.updateCityInfobox, data)
  }
})

// make global available
riot.EVT = E
riot.STORE = S
riot.control = C



// WEBPACK FOOTER //
// ./src/scripts/riot_setup.js